import { render, staticRenderFns } from "./DashboardAdminRegiones.vue?vue&type=template&id=36d1d156"
import script from "./DashboardAdminRegiones.vue?vue&type=script&lang=js"
export * from "./DashboardAdminRegiones.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdminRegiones.vue?vue&type=style&index=0&id=36d1d156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports